import angular from 'angular'

import { RolesResourceService } from '../user-role-resource.service'
import { UserSwitchingService } from './user-switching.service'

angular
  .module('webregister.services')
  .service('userSwitchingService', UserSwitchingService)
  .service('rolesResourceService', RolesResourceService)

angular
  .module('webregister.modals')
  .service('userSwitchingService', UserSwitchingService)
